import React from 'react';
import styles from './styles.module.css';

const Button = ({ onClick, children, customStyles }) => {
  return (
    <button
      className={[styles.button, customStyles].join(' ')}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
